import { Component, ElementRef, EventEmitter, HostListener, OnInit, Output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { EUserRole } from 'src/app/domain/enum/user-role';
import { ENavigationErrorType } from 'src/app/model/enum/navigation-error-type';
import { ENavigationRoute } from 'src/app/model/enum/navigation-route';
import { CoreData } from 'src/app/tools/core-data/core-data';
import { LoadingTask } from 'src/app/tools/ui/loading-task';
import { StringConverter } from 'src/app/tools/ui/string-converter';
import { environment } from 'src/environments/environment';
const { version: appVersion } = require('../../../../package.json');

@Component({
    selector: 'app-nav-menu',
    templateUrl: './nav-menu.component.html',
    styleUrls: ['./nav-menu.component.scss']
})
export class NavMenuComponent implements OnInit {
    ENavigationRoute = ENavigationRoute;
    @ViewChild('toggleButton', { read: ElementRef })
    toggler!: ElementRef;
    @Output() stateChanged = new EventEmitter<string>();
    isExpanded = false;

    AppName = environment.appName;
    AppVersion!: string;
    IsMeL = environment.isMel;

    get MELIconPath() {
        return this.CoreData.IsMobile ? 'assets/Logo-MEL-simple.png' : 'assets/02-white.png';
    }

    // this.CoreData.IsMobile ? 'assets/favicon-eab.ico' :
    get EABIconPath() {
        return 'assets/eurofins_blanc.png';
    }

    get IsMelConnect() {
        return environment.isMel;
    }

    constructor(
        private router: Router,
        public CoreData: CoreData) {

    }

    @HostListener('window:resize', ['$event'])
    onResize() {
        this.isMenuTogglerDisplayed();
    }

    ngOnInit() {
        this.AppVersion = appVersion;
    }

    collapse() {
        this.isExpanded = false;
    }

    toggle() {
        this.isExpanded = !this.isExpanded;
        if (!this.CoreData.IsMobile) {
            this.stateChanged.emit('210px');
            return;
        }

        if (this.isExpanded) {
            this.stateChanged.emit('320px');
        } else {
            this.stateChanged.emit('190px');
        }
    }

    getUserTypeLabel() {
        return StringConverter.getUserTypeName(this.CoreData.User?.Type as EUserRole);
    }

    isMenuTogglerDisplayed() {
        return this.toggler && window.getComputedStyle(this.toggler.nativeElement).display !== 'none';
    }

    IsLoggedIn() {
        return this.CoreData.IsLoggedIn;
    }

    // isUserASM() {
    //     return this.CoreData.User?.Type === EUserRole.ASMCentral || this.CoreData.User?.Type === EUserRole.ASMLocal;
    // }

    isTestingEnv() {
        return environment.name === 'UAT' || environment.name === 'DEV';
    }

    canAccessConfiguration() {
        return this.CoreData.User?.Type === EUserRole.Gestionnaire
    }

    goToHome() {
        this.router.navigate([ENavigationRoute.Home]);
    }

    logout() {
        this.CoreData.clearToken();
        this.router.navigate([ENavigationRoute.Error, { type: ENavigationErrorType.UnAuthenticated }]);
    }

    /* TODO ADD THESE LINKS IN ABOUT SECTION
    <a href="https://www.flaticon.com/free-icons/order" title="order icons">Order icons created by Eucalyp - Flaticon</a>
    <a href="https://www.flaticon.com/free-icons/inventory" title="inventory icons">Inventory icons created by Eucalyp - Flaticon</a>
    <a href="https://www.flaticon.com/free-icons/chemistry" title="chemistry icons">Chemistry icons created by Eucalyp - Flaticon</a>
    <a href="https://www.flaticon.com/free-icons/customs" title="customs icons">Customs icons created by Eucalyp - Flaticon</a>
    */
    getSpecificFiles(type: number) {
        switch (type) {
            case 1:
                window.open(`${window.location.origin}/assets/Juridique/CGU.pdf`, '_blank');
                break;
            case 2:
                window.open(`${window.location.origin}/assets/Juridique/RGPD.pdf`, '_blank');
                break;
        }
    }

    navigateTo(route: ENavigationRoute) {
        this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
            this.router.navigate([route]);
            this.toggle();
        })
    }
}
